import api from '../common/api/userApi';

const basePath = '/users';

export default {
  getList(params = {}) {
    return api.get(basePath, { params });
  },
  create(user) {
    return api.post(`${basePath}`, user);
  },
  get(userId, params = {}) {
    return api.get(`${basePath}/${userId}`, { params });
  },
  update(userId, account) {
    return api.put(`${basePath}/${userId}`, account);
  },
  delete(userId) {
    return api.delete(`${basePath}/${userId}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/userService.js